import React from 'react';

//This function based component is used to display the title and price
// Separated for the ease of placement in within different view of 
//  desktop and tablet, mobile views

const ProductTitlePrice = (props) => {
    const productPrice = props.price.map(item => {
        console.log(item.price);
        if(item.price) {
            return <p key={item.id}>${item.price}</p>
        } else {
            return <p>N/A</p>
        }
    })

    return (
        <div className='product-title-price'>
            <div className='product-title'> {props.title} </div>
            <div className='product-price'> {productPrice} </div>
        </div>
    )
}

export default ProductTitlePrice;


// WEBPACK FOOTER //
// ./src/components/product-title-price.js